module.exports = __webpack_public_path__ + "static/img/notification.9a76fda2.svg";